import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ScanData } from '../interfaces';
import { ScanDialogComponent } from '../views/scan-dialog/scan-dialog.component';
import { AuthorizationService } from './authorization.service';

@Injectable({
  providedIn: 'root'
})
export class ScanService {

  currentMask = '';

  currentUrl = '';

  data: ScanData = { url: `${location.origin}/api/v1/los/shipper-corp/piece0000` }

  constructor(private dialog: MatDialog, private authService: AuthorizationService,
    private router: Router) {
  }

  doScan() {
    const dialogRef = this.dialog.open(ScanDialogComponent, { width: '80%', disableClose: false, data: this.data });
    dialogRef.afterClosed().subscribe((data: ScanData) => {
      if (this.currentMask === '' || !this.authService.maskAvailable(this.currentMask)) {
        this.currentMask = this.authService.firstMaskAvailable() ?? '/';
      }
      this.currentUrl = data?.url ?? '';
      this.router.navigate([this.currentMask, { url: this.currentUrl }]);
    });
  }

  setMask(mask: string) {
    if (this.currentMask !== mask) {
      this.currentMask = mask;
      this.router.navigate([this.currentMask, { url: this.currentUrl }]);
    }
  }

}

